<!--
Novas funcionalidades adicionadas
- Mostra ou não os botões de ação, (Edit e Remove), default: false
:actions="true"
- Método chamado ao clicar no botão de Edit, é passado o item como parametro
v-on:edit-item="editEvent"
- Método chamado ao clicar no botão de Remove, é passado o item como parametro
v-on:delete-item="removeCulture"
- Mostra ou não o input de pesquisa do lado esquerdo
:leftSearch="true"
- Método chamado sempre que algo for digitado no input da esquerda, é passado o que foi digitado por parametro
v-on:search-action-left="searchEventLeft"
- Mostra ou não o input de pesquisa do lado direito
:rightSearch="true"
- Método chamado sempre que algo for digitado no input da direita, é passado o que foi digitado por parametro
v-on:search-action-right="searchEventRight"
- Mostra o botão ao lado do titulo do card esquerdo
:show-button-left="true"
- Seta o nome do botão
:button-left-value="'Nova Cultura'"
- Ação tomada quando clica no botão
v-on:button-left="test()"
-->
<template>
  <div class="vue-list-picker">
    <div class="list-picker-container list-picker-left">
      <div v-if="leftSearch" style="padding-bottom: 5px;">
        <slot v-bind:item="leftValues" name="leftSearch">
          <base-input
            v-model="leftValues"
            :placeholder="leftSearchPlaceholder"
            aria-describedby="button-addon2"
          />
        </slot>
      </div>
          <div
            class="list-picker-title"
            :class="getTitleClasses"
          >{{ titleLeft | textSubstr(titleSubstr) }}
            <base-button v-if="showButtonLeft" @click="buttonLeft()" type="neutral" size="sm" class="ml-3 newbutton">
            {{ buttonLeftValue }}
            </base-button>
          </div>
      <div class="list-picker-panel" ref="moverleft" :style="getStyles" v-loading="leftLoading">
        <div
          class="list-picker-item"
          v-for="item in unselectedItems"
          :key="item[contentKey]"
          :class="[getContentClasses, {'list-picker-selected': item.isSelected}]"
          @click="selectUnselectItem(item, unselectedItems)"
          @mousemove="selectItem(item, selectedItems)"
          @mousedown="startDrag"
        >
          <el-tooltip :disabled="!$scopedSlots.tooltip" :enterable="false" placement="top">
            <template slot="content">
              <slot v-bind:item="item" name="tooltip"></slot>
            </template>

            <div>
              {{ item[contentAttr] | textSubstr(contentSubstr) }}
              <div @click.stop @mousemove.stop @mousedown.stop style="float: right;" v-if="actions">
                <span @click="editItem(item)" class="btn btn-sm btn-icon-only text-success">
                  <i class="fa fa-pen fa-lg"></i>
                </span>
                <span @click="deleteItem(item)" class="btn btn-sm btn-icon-only text-success">
                  <i class="fa fa-trash fa-lg"></i>
                </span>
              </div>
            </div>
          </el-tooltip>
        </div>
      </div>
    </div>
    <div class="list-picker-actions">
      <el-tooltip content="Mover todos a direita" placement="top">
        <button @click="moveAllRight" :class="buttonClass">
          <img
            v-if="!this.$slots.moveAllRight"
            src="../../assets/chevrons-right.svg"
            alt="Chevrons right"
          />
          <slot name="moveAllRight" />
        </button>
      </el-tooltip>

      <el-tooltip content="Mover selecionados a direita" placement="top">
        <button @click="moveRight" class="mb-25" :class="buttonClass">
          <img v-if="!this.$slots.moveRight" src="../../assets/chevron-right.svg" alt="Chevron right" />
          <slot name="moveRight" />
        </button>
      </el-tooltip>

      <el-tooltip content="Mover selecionados a esquerda" placement="top">
        <button @click="moveLeft" :class="buttonClass">
          <img v-if="!this.$slots.moveLeft" src="../../assets/chevron-left.svg" alt="Chevron left" />
          <slot name="moveLeft" />
        </button>
      </el-tooltip>

      <el-tooltip content="mover todos a esquerda" placement="top">
        <button @click="moveAllLeft" class="mb-25" :class="buttonClass">
          <img
            v-if="!this.$slots.moveAllLeft"
            src="../../assets/chevrons-left.svg"
            alt="Chevrons left"
          />
          <slot name="moveAllLeft" />
        </button>
      </el-tooltip>

      <el-tooltip content="Desselecionar todos" placement="top">
        <button @click="unselectAll" :class="buttonClass">
          <img v-if="!this.$slots.unselectAll" src="../../assets/x.svg" alt="X icon" />
          <slot name="unselectAll" />
        </button>
      </el-tooltip>
    </div>
    <div class="list-picker-container list-picker-right">
      <div v-if="rightSearch" style="padding-bottom: 5px;">
        <input
          type="text"
          class="form-control"
          :placeholder="rightSearchPlaceholder"
          aria-describedby="button-addon2"
          v-once
          v-model="rightValues"
        />
      </div>
      <div
        class="list-picker-title"
        :class="getTitleClasses"
      >{{ titleRight | textSubstr(titleSubstr) }}</div>
      <div class="list-picker-panel" ref="moverright" :style="getStyles" v-loading="rightLoading">
        <div
          class="list-picker-item"
          v-for="item in selectedItems"
          :key="item[contentKey]"
          :class="[getContentClasses, {'list-picker-selected': item.isSelected}]"
          @click="selectUnselectItem(item, selectedItems)"
          @mousemove="selectItem(item, selectedItems)"
          @mousedown="startDrag"
        >
          <el-tooltip :disabled="!$scopedSlots.tooltip" :enterable="false" placement="top">
            <template slot="content">
              <slot v-bind:item="item" name="tooltip"></slot>
            </template>
            <div>
              {{ item[contentAttr] | textSubstr(contentSubstr) }}
              <div @click.stop @mousemove.stop @mousedown.stop style="float: right;" v-if="actions">
                <span @click="editItem(item)" class="btn btn-sm btn-icon-only text-success">
                  <i class="fa fa-pen mt-2 fa-lg"></i>
                </span>
                <span @click="deleteItem(item)" class="btn btn-sm btn-icon-only text-success">
                  <i class="fa fa-trash mt-2 fa-lg"></i>
                </span>
              </div>
            </div>
          </el-tooltip>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "VueListPicker",
  props: {
    leftValue: {
      type: String,
      default: ""
    },
    rightValue: {
      type: String,
      default: ""
    },
    leftItems: {
      type: Array,
      required: true
    },
    rightItems: {
      type: Array,
      required: true
    },
    movedItemLocation: {
      type: String,
      default: "top"
    },
    titleLeft: {
      type: String,
      default: "Items available"
    },
    buttonLeftValue: {
      type: String,
      default: "New"
    },
    titleRight: {
      type: String,
      default: "Items selected"
    },
    titleCentered: {
      type: Boolean,
      default: true
    },
    titleClass: {
      type: String,
      default: ""
    },
    titleSubstr: {
      type: Number,
      default: 20
    },
    buttonClass: {
      type: String,
      default: ""
    },
    contentKey: {
      type: String,
      default: "key"
    },
    contentAttr: {
      type: String,
      default: "content"
    },
    contentCentered: {
      type: Boolean,
      default: false
    },
    contentClass: {
      type: String,
      default: ""
    },
    contentSubstr: {
      type: Number,
      default: 23
    },
    minHeight: {
      type: String,
      default: "450px"
    },
    height: {
      type: String,
      default: ""
    },
    minWidth: {
      type: String,
      default: "220px"
    },
    width: {
      type: String,
      default: ""
    },
    actions: {
      type: Boolean,
      default: false
    },
    showButtonLeft: {
      type: Boolean,
      default: false
    },
    leftSearch: {
      type: Boolean,
      default: false
    },
    rightSearch: {
      type: Boolean,
      default: false
    },
    rightSearchPlaceholder: {
      type: String,
      default: 'Informe o nome de uma Cultura',
    },
    leftSearchPlaceholder: {
      type: String,
      default: 'Informe o nome de uma Cultura',
    },
    leftLoading: {
      type: Boolean,
      default: false,
    },
    rightLoading: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    popoverIndex: -1,
    loading: false,
    dragging: false,
    lastMovedItem: null
  }),
  filters: {
    textSubstr(value, qtd = 250, mask = "...") {
      return value && value.length > qtd
        ? `${value.substring(0, qtd)}${mask}`
        : value;
    }
  },
  computed: {
    leftValues: {
      get(){
        return this.leftValue;
      },
      set(val){
        this.$emit("update:left-value", val)
        this.$emit("search-action-left", val);
      }

    },
    rightValues: {
      get(){
        return this.rightValue;
      },
      set(val){
        this.$emit("search-action-right", val);
      }

    },
    unselectedItems: {
      get() {
        return this.leftItems;
      },
      set(val) {
        this.$emit("leftItems:update", val);
      }
    },
    selectedItems: {
      get() {
        return this.rightItems;
      },
      set(val) {
        this.$emit("rightItems:update", val);
      }
    },
    getTitleClasses() {
      const { titleClass, titleCentered } = this;

      return titleClass || { "text-center": titleCentered };
    },
    getContentClasses() {
      const { contentClass, contentCentered } = this;

      return contentClass || { "text-center": contentCentered };
    },
    getStyles() {
      const { height, minHeight, minWidth, width } = this;

      return {
        height,
        minHeight,
        minWidth,
        width
      };
    }
  },
  created() {
    this.unselectedItems =
      this.unselectedItems && this.unselectedItems.length
        ? this.unselectedItems.map(it => ({ ...it, isSelected: false }))
        : [];
    this.selectedItems =
      this.selectedItems && this.selectedItems.length
        ? this.selectedItems.map(it => ({ ...it, isSelected: false }))
        : [];
  },
  mounted() {
    document.addEventListener("mouseup", this.stopDrag);
  },
  beforeDestroy() {
    document.removeEventListener("mouseup", this.stopDrag);
  },
  methods: {
    startDrag() {
      this.dragging = true;
    },
    teste(str){console.log(str)},
    stopDrag() {
      this.dragging = false;
    },
    selectUnselectItem(item, items) {
      this.setItem(item, items, !item.isSelected);
    },
    setItem(item, items, val) {
      let itemBase = item;

      if (items && items.length && !itemBase) {
        itemBase = items[0];
      }

      if (!itemBase) return;

      itemBase.isSelected = val;
      this.$forceUpdate();
    },
    selectItem(item, items) {
      if (this.dragging) {
        const VALUE_IS_SET_TO_TRUE = true;
        this.setItem(item, items, VALUE_IS_SET_TO_TRUE);
      }
    },
    moveRight() {
      this.moveOne(
        this.unselectedItems,
        this.selectedItems,
        "moverleft",
        "move-right"
      );
    },
    moveLeft() {
      this.moveOne(
        this.selectedItems,
        this.unselectedItems,
        "moverright",
        "move-left"
      );
    },
    unselect(items) {
      if (!items.length) return;

      items.forEach(it => {
        it.isSelected = false;
      });
      this.$forceUpdate();
    },
    unselectAll() {
      this.unselect(this.unselectedItems);
      this.unselect(this.selectedItems);
      this.$emit("unselect-all");
    },
    moveOne(firstArray, secondArray, refsName, event) {
      const items = firstArray.filter(itm => itm.isSelected);
      if (!items || !items.length) return;

      items.forEach(item => {
        firstArray.forEach((it, idx) => {
          if (it[this.contentKey] === item[this.contentKey]) {
            firstArray.splice(idx, 1);
            this.$emit(event, it);

            if (this.movedItemLocation === "top") {
              secondArray.unshift(it);
              this.$refs[refsName].scrollTop = 0;
            } else {
              secondArray.push(it);
            }
          }
        });
      });

      this.unselectAll();
    },
    editItem(item) {
      this.$emit("edit-item", item);
    },
    deleteItem(item) {
      this.$emit("delete-item", item);
    },
    buttonLeft(){
      this.$emit("button-left");
    },
    moveAllRight() {
      this.$emit('will-move-all-right', this.unselectedItems)
      this.moveAll(this.unselectedItems, this.selectedItems);
      this.$emit("move-all-right", this.selectedItems);
    },
    moveAllLeft() {
      this.$emit('will-move-all-left', this.selectedItems)
      this.moveAll(this.selectedItems, this.unselectedItems);
      this.$emit("move-all-left", this.unselectedItems);
    },
    moveAll(firstArray, secondArray) {
      for (let i = firstArray.length - 1; i >= 0; i--) {
        let item = firstArray[i];
        firstArray.splice(i, 1);
        secondArray.push(item);
      }

      this.unselectAll();
    }
  }
};
</script>

<style scoped>
.vue-list-picker {
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen",
    "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue",
    sans-serif;
  -webkit-font-smoothing: antialiased;
  text-rendering: optimizeLegibility;
  display: flex;
  flex-flow: row nowrap;
  cursor: default;
}
.vue-list-picker .list-picker-container {
  flex: 1 1 auto;
  border: 1px solid #ddd;
  background: #f9f9f9;
  border-radius: 3px;
  overflow: auto;
  display: flex;
  flex-direction: column;
}
.vue-list-picker .list-picker-panel {
  min-height: 400px;
  overflow-y: auto;
}
.vue-list-picker .list-picker-item::selection {
  background: unset;
}
.vue-list-picker .list-picker-actions {
  flex: 0 0 auto;
  align-self: center;
  padding: 0 15px;
}
.vue-list-picker .list-picker-actions > button {
  width: 50px;
  height: 50px;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.vue-list-picker .list-picker-item,
.vue-list-picker .list-picker-selected,
.vue-list-picker .list-picker-title {
  padding: 8px 10px;
  border-bottom: 1px solid #ccc;
}
.vue-list-picker .list-picker-title {
  background: #fafafa;
  color: #0052c0;
  font-size: 1.1em;
  font-weight: 600;
}
.vue-list-picker .list-picker-selected {
  background: #0052c0;
  color: #f0f0f0;
  font-weight: 600;
}
.vue-list-picker .mb-25 {
  margin-bottom: 25px;
}
.vue-list-picker .text-center {
  text-align: center;
}
.newbutton{
  float: right;
  bottom: 5px;
}

@media (max-width: 768px) {
  img {
    transform: rotate(90deg); /* Rotação de 90 graus */
    width: 100%;
    height: auto;
  }
  .vue-list-picker {
    flex-direction: column;
  }
  .vue-list-picker .list-picker-container {
    border: none;
    border-bottom: 1px solid #ddd;
    border-radius: 0;
  }
  .vue-list-picker .list-picker-actions {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin-top: 70px;
    margin-left: -160px;
  }
  .vue-list-picker .list-picker-actions > button {
    margin-bottom: 0px;
    width: 4px;
  }
  .vue-list-picker .list-picker-item,
  .vue-list-picker .list-picker-selected,
  .vue-list-picker .list-picker-title {
    padding: 5px 10px;
  }
  .vue-list-picker .list-picker-title {
    font-size: 1em;
  }
  .vue-list-picker .list-picker-selected {
    font-size: 0.9em;
  }
}
</style>
